var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editMode)?_c('div',{staticClass:"add-item icon drag-zone",style:((_vm.hoverOver)? `background-image:url(${require('../assets/anchor-solid.svg')})` : ''),on:{"click":function($event){return _vm.$emit('click')},"drop":_vm.onDrop,"dragover":function($event){$event.preventDefault();},"dragenter":_vm.dragEnter,"dragleave":_vm.dragLeave}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }